import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/services/api'
import { Boost, BoostCreateRequest, BoostUpdateRequest } from '@/types'
import { toast } from 'sonner'

const BOOSTS_QUERY_KEY = 'boosts'

export const useBoosts = () => {
  return useQuery<Boost[]>({
    queryKey: [BOOSTS_QUERY_KEY],
    queryFn: async () => {
      const { data } = await api.get('/credit-costs/boosts')
      return data
    },
  })
}

export const useCreateBoost = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (boost: BoostCreateRequest) => {
      const { data } = await api.post('/credit-costs/boosts', boost)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BOOSTS_QUERY_KEY] })
      toast.success('Boost creado')
    },
  })
}

export const useUpdateBoost = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, updates }: { id: string; updates: BoostUpdateRequest }) => {
      const { data } = await api.patch(`/credit-costs/boosts/${id}`, updates)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BOOSTS_QUERY_KEY] })
      toast.success('Boost actualizado')
    },
  })
}

export const useToggleBoost = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await api.post(`/credit-costs/boosts/${id}/toggle`)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BOOSTS_QUERY_KEY] })
      toast.success('Estado del boost actualizado')
    },
  })
}
